// Keep the active cart implementation behind the common drawer interface.
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('sc-cart-drawer') ||
          document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('sc-cart-drawer') || document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        /* elbDev - add selected pot to cart */
        let potId = '';
        const potRadios = document.querySelectorAll('[data-pot-upsell-radio-btn] input');
        const parentVariantId = formData.get('id');

        if (potRadios) {
          const selectedRadio = Array.from(potRadios).find(radio => radio.checked && radio.dataset.variantId);
          if (selectedRadio) {
            potId = selectedRadio.dataset.variantId;
          }
        }

        if (potId) {
          formData.append('items[1][id]', potId);
          formData.append('items[1][quantity]', '1');
          if (parentVariantId) formData.append('items[1][parent_id]', parentVariantId);
        }

        if (!potId) {
          const selectedScPot = (this.closest('section') || document).querySelector(
            'sc-pot-upsell-widget [data-upsell-item][data-active="true"]:not([data-current-product])'
          );

          if (selectedScPot?.dataset.variantId) {
            formData.append('items[1][id]', selectedScPot.dataset.variantId);
            formData.append('items[1][quantity]', '1');
            if (parentVariantId) formData.append('items[1][parent_id]', parentVariantId);
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              // SC: Falls back to the cart page when the selected cart has no drawer.
              if (window.scCartExperiment?.scIsNative() || !window.upcartGetCart) {
                window.location = window.routes.cart_url;
              }
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            // SC: Routes add-to-cart rendering to the selected cart implementation.
            const scRenderCart = () => {
              if (typeof window.scCartExperiment?.scAfterAdd === 'function') {
                window.scCartExperiment.scAfterAdd(response, { nativeCart: this.cart });
              } else if (!window.scCartExperiment || window.scCartExperiment.scIsNative()) {
                this.cart.renderContents(response);
              }
            };
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    scRenderCart();
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              scRenderCart();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            // SC: Updates empty state only when the native drawer owns the cart.
            if (window.scCartExperiment?.scIsNative() && this.cart?.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
